import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { clearSession } from '~/lib/session';
import { useGlobalStore } from '~/stores/store-provider';

export default function Logout() {
    const navigate = useNavigate();
    const resetAll = useGlobalStore((state: any) => state.resetAll);

    useEffect(() => {
        clearSession();
        resetAll();
        navigate('/', { replace: true });
    }, [navigate, resetAll]);

    return null;
}
